import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { Outlet } from 'react-router';
import { useScreen } from '../../hooks';
import { AirshipHorizontalIcon } from '../../icons';
import AirshipMarketingInfoCard from '../cards/AirshipMarketingInfoCard';

const AuthFrame: React.FC = () => {
  const { isMobile } = useScreen();
  const logo = <AirshipHorizontalIcon height={'6rem'} />;
  const infoCard = <AirshipMarketingInfoCard />;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        height: '100vh',
        width: '100vw',
      }}
    >
      {isMobile && <Box sx={{ display: 'flex' }}>{logo}</Box>}
      <Box
        sx={{
          display: 'flex',
          p: [2, 2, 3],
          flexDirection: ['column-reverse', 'row'],
          gap: 3,
          flex: 1,
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          {!isMobile && (
            <Box sx={{ display: 'flex', alignSelf: 'flex-start' }}>{logo}</Box>
          )}
          {infoCard}
        </Box>
        <Box
          component={Paper}
          sx={{
            p: 2,
            width: ['100%', '40%'],
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default AuthFrame;
